import axios from 'axios';

export class SecurityError extends Error {
    constructor(message, code) { super(message); this.code = code; }
}
export function createMerchantSecurityClient(api = process.env.REACT_APP_API) {
    let csrf = null;
    const call = async (method, path, body) => {
        if (method === 'post' && !csrf) throw new SecurityError('인증 설정을 다시 조회해주세요.', 4032);
        let response;
        try {
            response = await axios({ method, url: `${api}/api/security${path}`, withCredentials: true, timeout: 15000,
                ...(method === 'post' ? { data: body, headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrf } } : {}) });
        } catch (error) {
            // Do not expose request/config objects containing passwords, codes or proofs.
            const result = error.response?.data;
            throw new SecurityError(result?.msg || '인증 서버에 연결하지 못했습니다. 다시 시도해주세요.', result?.code);
        }
        if (response.data?.code !== 1000) throw new SecurityError(response.data?.msg || '인증 요청을 처리하지 못했습니다.', response.data?.code);
        return response.data.data;
    };
    return {
        async settings() {
            csrf = null;
            const data = await call('get', '/settings');
            if (typeof data?.enabled !== 'boolean' || !data.login || !data.withdraw) throw new SecurityError('인증 정책 응답을 확인하지 못했습니다.');
            if (data.enabled && (typeof data.csrf_token !== 'string' || !data.csrf_token || !Number.isInteger(data.version))) throw new SecurityError('인증 설정 정보가 올바르지 않습니다.');
            csrf = data.enabled ? data.csrf_token : null;
            return data;
        },
        post: (path, body) => call('post', path, body),
        clear() { csrf = null; },
    };
}
export const securityMethods = ['PIN', 'EMAIL'];
export const allowedMethods = policy => Array.isArray(policy?.allowed) ? policy.allowed.filter(method => securityMethods.includes(method)) : [];
export function preferredMethod(policy, preference) {
    const allowed = allowedMethods(policy);
    return allowed.includes(policy?.method) ? policy.method : allowed.includes(preference) ? preference : allowed[0] || '';
}
export const securityErrorMessage = error => ({
    4091: '설정이 변경되었습니다. 설정을 다시 조회한 후 진행해주세요.',
    4100: '인증이 만료되었거나 일치하지 않습니다. 다시 인증해주세요.',
    4230: '인증이 잠겼거나 복구가 필요합니다. 잠금 안내를 확인해주세요.',
    4290: '인증 요청 횟수를 초과했습니다. 잠시 후 다시 시도해주세요.',
    9999: '로그인 세션이 만료되었습니다. 다시 로그인해주세요.',
    5033: '인증 기능이 비활성화되었습니다. 로그인 화면으로 돌아가 다시 로그인해주세요.',
})[error?.code] || error?.message || '인증 처리 중 오류가 발생했습니다.';
